import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import {
  CitySearchResSchema,
  InputValuesResSchema,
  SearchSelectCitiesDto,
} from "../models";

export abstract class SearchInputsApi {
  static getCountries = async () => {
    return withSchemaValidation(
      GbApiRequestService.get("userApi", {
        params: { requestType: "countryForSearch" },
      }),
      SearchSelectCitiesDto,
    );
  };
  static getInputsOptions = async () => {
    return withSchemaValidation(
      GbApiRequestService.get("userApi", {
        params: { requestType: "searchParams" },
      }),
      InputValuesResSchema,
    );
  };
  static getCitiesByCountry = async (cityId: string) => {
    return withSchemaValidation(
      GbApiRequestService.get("userApi", {
        params: {
          requestType: "fillSearchBoxes",
          searchBox: "city",
          params: cityId,
        },
      }),
      CitySearchResSchema,
    );
  };
}
